import { render, staticRenderFns } from "./ParticipantDialog.vue?vue&type=template&id=847c8b70&"
import script from "./ParticipantDialog.vue?vue&type=script&lang=js&"
export * from "./ParticipantDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports